import { render, staticRenderFns } from "./Mobilebar.vue?vue&type=template&id=2c2db678&scoped=true"
import script from "./Mobilebar.vue?vue&type=script&lang=js"
export * from "./Mobilebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2db678",
  null
  
)

export default component.exports